module.exports = __webpack_public_path__ + "/dist/assets/fonts/fa-regular-400.eot";